import * as React from 'react';
import ErrorExclamationTriangle from '../assets/icons/ErrorExclamationTriangle.esm.js';
import IconClose from '../assets/icons/IconClose.esm.js';
import InfoCircle from '../assets/icons/InfoCircle.esm.js';
import SuccessCheckCircle from '../assets/icons/SuccessCheckCircle.esm.js';
import WarningExclamantionCircle from '../assets/icons/WarningExclamationCircle.esm.js';
import classNames from 'classnames';

var NvUserNotification = function (_a) {
    var _b = _a.classes, classes = _b === void 0 ? {} : _b, _c = _a.message, message = _c === void 0 ? '' : _c, messageType = _a.messageType, style = _a.style, onClose = _a.onClose, isOpen = _a.isOpen, children = _a.children;
    if (!children && !message)
        return null;
    var getMessageTypeStyle = function () {
        // do not style the component with a background or border
        // if the style is textOnly
        if (style === 'textOnly') {
            return 'nv-notification-text-only';
        }
        else {
            var messageTypesStyle = {
                error: 'nv-notification--error',
                info: 'nv-notification--info',
                success: 'nv-notification--success',
                warning: 'nv-notification--warning',
            };
            return messageTypesStyle[messageType];
        }
    };
    if (!isOpen)
        return null;
    return (React.createElement("div", { className: classNames('nv-notification', classes.root) },
        React.createElement("div", { className: classNames('nv-notification-wrapper', getMessageTypeStyle()), "data-testid": "container" },
            messageType === 'info' && React.createElement(InfoCircle, null),
            messageType === 'success' && React.createElement(SuccessCheckCircle, null),
            messageType === 'error' && React.createElement(ErrorExclamationTriangle, null),
            messageType === 'warning' && React.createElement(WarningExclamantionCircle, null),
            React.createElement("div", { className: "nv-notification-message" }, message || children),
            style === 'large' && (React.createElement("button", { className: "nv-notification-close-icon", "data-testid": "button", onClick: onClose },
                React.createElement(IconClose, null))))));
};

export { NvUserNotification as default };
//# sourceMappingURL=NvUserNotification.esm.js.map
